export default {
    namespaced: true,
    state: () => ({
        search: '',
        status: 'All',
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "regdate" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        isTableOptionsInitialized: false
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_STATUS (state, payload){
            state.status = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
    },
    getters: {
        getSearch: (state) => state.search,
        getStatus: (state) => state.status,
        getTableOptions: (state) => state.tableOptions,
    }
}